export type GetImageResolution = {
  size: {
    original: {
      height: number,
      width: number,
    },
  },
}

function getImageResolution(image: GetImageResolution) {
  const resolution = {
    label: 'High',
    width: 0,
    height: 0,
    warn: false,
  }

  if (image?.size){
    const lowResValue = 3600 // ~1200x900px
    const mediumResValue = 6400 // ~1600x1200px
    const { height, width } = image.size.original || {}
    const imageRes = (width * height) / 300

    if (imageRes < mediumResValue){
      resolution.label = 'Medium'
      resolution.warn = true
    }

    if (imageRes < lowResValue){
      resolution.label = 'Low'
      resolution.warn = true
    }

    resolution.width = width
    resolution.height = height
  }

  return resolution
}

export default getImageResolution
